// @ts-expect-error Untyped module
import DomainPattern from 'PatternValidationJS/patterns/Domain';
import Url from 'urlinator/Url';
import { CompanyDomainErrors, ValidationStatus } from '../types';
import { hasEmoji } from './matchers';

const hasPathname = domain => {
  const domainUrl = new Url(domain);
  return domainUrl.pathname.length > 1;
};

export const syncCompanyDomainValidator = (domain, isUsingOptionalDomain) => {
  const domainUrl = new Url(domain);

  if (!domainUrl.hostname || !DomainPattern.test(domainUrl.hostname)) {
    return CompanyDomainErrors.generic;
  }

  if (!isUsingOptionalDomain && domain.includes('hubspot-freecmstools.com')) {
    return CompanyDomainErrors.generic;
  }

  if (hasPathname(domain)) {
    return CompanyDomainErrors.genericSubpages;
  }

  if (hasEmoji(domain)) {
    return CompanyDomainErrors.generic;
  }

  return ValidationStatus.VALID;
};